import { Center, Flex, Tooltip } from '@chakra-ui/react';
import { KFormLabel } from '@/ui-library/components';
import { InfoCircle } from '@kula-ai/icons-core';
import { Switch } from '@kula-ai/components';

export const SwitchField = ({ item, field, formik }) => {
  if (!item) return null;
  const {
    name,
    isEditable = true,
    label,
    style,
    subLabel,
    subLabelStyles,
    labelStyles,
    labelInfoText,
  } = item;

  const { setFieldValue } = formik || {};

  const handleCheckedChange = (checked: boolean) => {
    // Formik's field.onChange expects a synthetic event with target — not a raw boolean.
    // Kula Switch calls onCheckedChange(checked: boolean); use setFieldValue (same as NoteTakerField).
    setFieldValue?.(name, checked);
  };

  const defaultStyles = {
    borderRadius: '8px',
  };

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="space-between"
        style={{ ...defaultStyles, ...style }}
      >
        <Flex flexDir="column">
          <Flex>
            {label && (
              <KFormLabel
                htmlFor={name}
                style={{
                  ...labelStyles,
                }}
              >
                {label}
              </KFormLabel>
            )}
            {labelInfoText && (
              <Tooltip variant="default" label={labelInfoText}>
                <Center ml="6px" w="18px" h="18px">
                  <InfoCircle
                    size={16}
                    color="var(--kula-colors-secondary-700)"
                    className="kula-icon"
                  />
                </Center>
              </Tooltip>
            )}
          </Flex>
          {subLabel && (
            <KFormLabel
              htmlFor={name}
              style={{ ...subLabelStyles }}
              requiredIndicator={null}
              variant="subLabel"
            >
              {subLabel}
            </KFormLabel>
          )}
        </Flex>
        <Switch
          checked={Boolean(field?.value)}
          disabled={!isEditable}
          onCheckedChange={handleCheckedChange}
          id={name}
        />
      </Flex>
    </>
  );
};
